import React from 'react';
import isEmpty from 'lodash/isEmpty';

function addCommas(nStr) {
    if (!nStr) return '';
    nStr += '';
    var comma = /,/g;
    nStr = nStr.replace(comma, '');
    const x = nStr.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

function FormInput(props) {
    let {
        label = '',
        path,
        index,
        value = '',
        error = '',
        type = 'text',
        readOnly = false,
        onChange,
        onBlur,
        fullWidth,
        validator,
        min = -99999,
        mask = '',
        refProp,
        style = {},
        InputProps = {},
        multiline = false,
        rows = 1,
    } = props;

    const hasError = !isEmpty(error);

    let extraProps = {};
    if (min !== -99999)
        extraProps = {
            min
        };

    const handleInputChange = (event) => {
        if (readOnly) return;
        if (!onChange) return;
        if (['number', 'decimal', 'currency'].includes(type) && event.target.value === '')
            return onChange(null, path, index);

        if (type === 'number')
            return onChange(event.target.value.replace(/[^0-9]/g, ''), path, index);
        if (type === 'decimal') {
            let dSplit = event.target.value.split('.');
            if (dSplit.length === 2 && dSplit[1].length > 2) {
                return onChange(value.replace(/,/g, '').replace(/[^0-9.]/g, ''), path, index);
            }
            return onChange(event.target.value.replace(/,/g, '').replace(/[^0-9.]/g, ''), path, index);
        }
        if (type === 'currency') {
            let dSplit = event.target.value.split('.');
            if (dSplit.length === 2 && dSplit[1].length > 2) {
                return onChange(value.replace(/,/g, '').replace(/[^0-9.]/g, ''), path, index);
            }
            return onChange(event.target.value.replace(/,/g, '').replace(/[^0-9.]/g, ''), path, index);
        }
        onChange(event.target.value, path, index);
    };

    return (
        <div style={{ ...style, display: 'flex', flexDirection: 'column', marginTop: '16px', width: fullWidth ? '100%' : 'auto' }}>
            {label && <label htmlFor={`input-${path}`}>{label}</label>}
            {!mask &&
                (multiline ? (
                    <textarea
                        id={`input-${path}`}
                        value={value}
                        onChange={handleInputChange}
                        onBlur={event => onBlur && onBlur(event.target.value, path, validator)}
                        {...extraProps}
                        ref={refProp}
                        rows={rows}
                        style={{ width: '100%', padding: '8px', borderColor: hasError ? 'red' : '#ccc', borderWidth: '1px', borderStyle: 'solid', borderRadius: '4px' }}
                        {...InputProps}
                    />
                ) : (
                    <input
                        id={`input-${path}`}
                        type={'text'}
                        value={['decimal', 'currency'].includes(type) ? addCommas(value) : value}
                        onChange={handleInputChange}
                        onBlur={event => onBlur && onBlur(event.target.value, path, validator)}
                        {...extraProps}
                        ref={refProp}
                        style={{ width: '100%', padding: '8px', borderColor: hasError ? 'red' : '#ccc', borderWidth: '1px', borderStyle: 'solid', borderRadius: '4px' }}
                        {...InputProps}
                    />
                ))}
            {hasError && <span style={{ color: 'red', marginTop: '8px' }}>{error}</span>}
        </div>
    );
}

export default FormInput;
